
/**
  * @ngdoc component
  * @name MODULE_NAME.component:account
  *  
  * @param {Function} onUpdatePassword Description
  *
  * @description
  * description
  * 
*/
(function (itxApp) {

    'use strict';

    var ItxFullChangePasswordCmp = {
        bindings: {
            onUpdatePassword: '&'
        },
        controller: ItxFullChangePasswordCmpCtrl,
        templateUrl: 'full-change-password.component.html'
    };

    ItxFullChangePasswordCmpCtrl.$inject = [
        '$scope', 
        'ItxLoaderFct', 
        'ItxErrorMessagesFct',
    ];

    function ItxFullChangePasswordCmpCtrl(
        $scope, 
        ItxLoaderFct, 
        ItxErrorMessagesFct
    ) {
        var _this = this;
        _this.fullChangePasswordModel = null;
        _this.fullChangePasswordForm = null;
        _this.passwordValid=false;
        _this.hasOneNumber = true;
        _this.isLengthMin = true;
        _this.isLowerOneCharacter = true;
        _this.isUpperOneCharacter = true;
        _this.isRepeatCharacter = true;
        _this.captchaId = null;

         _this.validatePassword= function(){

              if(_this.fullChangePasswordModel.newPassword == undefined){
                _this.fullChangePasswordModel.newPassword= '';
            }
            
            var hasNumber= /\d/.test(_this.fullChangePasswordModel.newPassword);
            _this.hasOneNumber = !hasNumber;
            
            
            var length= /.{8,}/.test(_this.fullChangePasswordModel.newPassword); 
            _this.isLengthMin = !length;

            var patternLowerOneCharacter = new RegExp(".*[a-z]");
            var isLoChar=  patternLowerOneCharacter.test(_this.fullChangePasswordModel.newPassword);
            _this.isLowerOneCharacter = !isLoChar;
            
            var patternUpperOneCharacter = new RegExp(".*[A-Z]");
            var isUpChar=  patternUpperOneCharacter.test(_this.fullChangePasswordModel.newPassword);
            _this.isUpperOneCharacter = !isUpChar;

            _this.isRepeatCharacter = !_this.isRepeatChar();

            var passWordValid= _this.isRepeatChar() &&  !_this.hasOneNumber &&  !_this.isLengthMin &&  !_this.isLowerOneCharacter && !_this.isUpperOneCharacter ;
             _this.passwordValid= passWordValid;

        }
    
         _this.isRepeatChar = function () {
            if(_this.fullChangePasswordModel.newPassword == ""){
                return false;
            }else{
                var d = _this.fullChangePasswordModel.newPassword;
                return   /^(?!.*(.)\1{3})^.*$/.test(d);
            }
        };

        _this.updatePassword = function () {
            _this.fullChangePasswordForm.$setSubmitted();
            if (_this.fullChangePasswordForm.$valid) {
                ItxLoaderFct.show();

                var captchaObj = {
                    'captchaId': _this.captchaId,
                    'captchaValue': _this.fullChangePasswordModel.captchaResponse
                }

                joyr.rest.xRestUpdateUserPassword(
                    _this.fullChangePasswordModel.oldPassword,
                    _this.fullChangePasswordModel.newPassword,
                    captchaObj)
                    .done(function () {
                        _this.onUpdatePassword({
                            passwordModel:  _this.fullChangePasswordModel
                        });
                        resetForm();
                    })
                    .Catch(function (error) {
                        ItxErrorMessagesFct.dialog(error.errorMessage);
                    })
                    .Finally(function () {
                        ItxLoaderFct.hide();
                        $scope.$broadcast('captcha:reloadImage');
                        $scope.$apply();
                    });
            }
        };

        function resetForm() {
            if (_this.fullChangePasswordForm) {
                _this.fullChangePasswordModel = {};
                _this.fullChangePasswordForm.$setPristine();
                _this.fullChangePasswordForm.$setUntouched();
            }
        }
    }

    angular.module('itxApp.common')
        .component('itxFullChangePassword', ItxFullChangePasswordCmp);

})();